import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'user_badges';

export const BADGE_DEFINITIONS = {
  first_course: { id: 'first_course', name: 'First Steps', description: 'Complete your first course', icon: '🎯' },
  course_complete: { id: 'course_complete', name: 'Course Graduate', description: 'Complete a course', icon: '📜' },
  five_courses: { id: 'five_courses', name: 'Dedicated Learner', description: 'Complete 5 courses', icon: '⭐' },
  reviewer: { id: 'reviewer', name: 'Reviewer', description: 'Leave a course review', icon: '✍️' },
};

/**
 * Get all badges earned by a user.
 */
export async function getBadgesForUser(userId) {
  if (!userId) return [];
  const q = query(collection(db, COLLECTION), where('userId', '==', userId));
  const snap = await getDocs(q);
  const list = [];
  snap.forEach((docSnap) => {
    const d = docSnap.data();
    const def = BADGE_DEFINITIONS[d.badgeId] || { id: d.badgeId, name: d.badgeId, description: '', icon: '🏅' };
    list.push({
      id: docSnap.id,
      badgeId: d.badgeId,
      earnedAt: d.earnedAt,
      ...def,
    });
  });
  list.sort((a, b) => (b.earnedAt?.toMillis?.() ?? 0) - (a.earnedAt?.toMillis?.() ?? 0));
  return list;
}

/**
 * Award a badge if not already earned. Returns true if awarded.
 */
export async function awardBadge(userId, badgeId) {
  if (!userId || !badgeId) return false;
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    where('badgeId', '==', badgeId)
  );
  const snap = await getDocs(q);
  if (!snap.empty) return false;
  await addDoc(collection(db, COLLECTION), {
    userId,
    badgeId,
    earnedAt: serverTimestamp(),
  });
  return true;
}
